<template>
	<div class="candy" v-if="p_candy">
		<template v-if="!c_product_discount_bbva">
			<div class="candy-img">
				<a @click.prevent="m_show_candy(p_candy)">
					<img :src="c_get_src" :alt="p_candy.strDescription" />
				</a>
			</div>
			<div class="candy-content">
				<div class="candy-title">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strTitle }}</span>
					</a>
				</div>
				<div class="candy-description">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strDescription }}</span>
					</a>
				</div>
				<div class="candy-price">
					<span v-if="!c_product_ypf">${{ (p_candy.SalePrice / 100).toLocaleString('es-AR') }}</span>
					<span v-else>{{ m_get_price_ypf(p_candy) }}</span>
				</div>
				<div class="candy-price-wtax" v-if="p_candy.SalePriceWTax > 0 && !c_product_ypf">
					<span>Precio sin impuestos nacionales: ${{ (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') }}</span>
				</div>
				<div v-if="!c_product_ypf" class="candy-descuentos">
					<div class="candy-descuentos-content" v-html="m_get_discountbytitle()"></div>
				</div>
				<div v-else class="candy-ypfserviclub">
					<span class="bold">SOCIO YPF SERVICLUB</span><br><span>Canjeá tus KMS por descuentos</span>
				</div>
				<div v-if="!c_product_ypf" class="candy-cuotas">
					<span>3 cuotas sin interes con</span>
					<img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
				</div>
				<div class="candy-button">
					<div class="row">
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">MÁS INFO</a>
						</div>
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">COMPRAR</a>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="candy-img">
				<a @click.prevent="m_show_candy(p_candy)">
					<img :src="c_get_src" :alt="p_candy.strDescription" />
				</a>
			</div>
			<div class="candy-content">
				<div class="candy-title">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strTitle }}</span>
					</a>
				</div>
				<div class="candy-description">
					<a @click.prevent="m_show_candy(p_candy)">
						<span>{{ p_candy.strDescription }}</span>
					</a>
				</div>
				<div class="candy-discount">
					<span v-html="c_product_discount_bbva_msge"></span>
				</div>
				<div class="candy-price">
					<span>${{ (p_candy.SalePrice / 100).toLocaleString('es-AR') }}</span>
				</div>
				<div class="candy-price-wtax" v-if="p_candy.SalePriceWTax > 0">
					<span>Precio sin impuestos nacionales: ${{ (p_candy.SalePriceWTax / 100).toLocaleString('es-AR') }}</span>
				</div>
				<div class="candy-cuotas">
					<span>3 cuotas sin interes con</span>
					<img :src="$root.d_get_url_merch + 'images/bbva.png?v=' + $root.d_get_date_version_cache" />
				</div>
				<div class="candy-button">
					<div class="row">
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">MÁS INFO</a>
						</div>
						<div class="col-xs-6">
							<a @click.prevent="m_show_candy(p_candy)">COMPRAR</a>
						</div>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import $ from "jquery";
import moment from "moment";

export default {
	name: 'candytickethome',
	props: {
		p_candy: { type: Object, default: () => null }
	},
	computed: {
		c_get_src: function () {
			if (!this.p_candy.strCssClass.includes('gif')) {
				return this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.png?v=' + this.$root.d_get_date_version_cache;
			}
			else {
				return this.$root.d_get_url_candy_images + this.p_candy.strMCode + '.gif?v=' + this.$root.d_get_date_version_cache;
			}
		},
		c_product_ypf: function () {
			var is_product_ypf = false;

			this.p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 4) {
					is_product_ypf = true;
				}
			});

			return is_product_ypf;
		},
		c_product_discount_bbva: function () {
			var is_product_discount_bbva = false;

			var productList = this.$root.d_get_discount_bbva_product_list.split(';');

			productList.forEach(product => {
				if (product != '' && product == this.p_candy.strMCode) {
					is_product_discount_bbva = true;
				}
			});

			return is_product_discount_bbva;
		},
		c_product_discount_bbva_msge: function () {
			var message = "";

			var productMsgs = this.$root.d_get_discount_bbva_product_msgs.split(';;');

			productMsgs.forEach(productMsg => {
				var productMsgList = productMsg.split('--');

				if (productMsgList[0] != '' & productMsgList[0] == this.p_candy.strMCode) {
					message = productMsgList[1];
				}
			});

			return message;
		}
	},
	methods: {
		m_show_candy: function (p_candy) {
			this.$root.m_show_popup_candy_home(p_candy);
		},
		m_get_discountbytitle: function () {
			var plist = this.$root.d_get_discount_msg_productlist.split(';;');
			var message = "NO";
			var msgdefault = `<span>Hasta 20% OFF</span><img src="${this.$root.d_get_url_merch}images/logo-cinemarkclub.png?v=${this.$root.d_get_date_version_cache}" />`;

			plist.forEach(p => {
				if (p.includes(this.p_candy.strMCode)) {
					var mcode_msg = p.split('--');
					message = mcode_msg[1];
				}
			});

			if (message == "NO") {
				return msgdefault;
			}
			else {
				return message;
			}
		},
		m_get_price_ypf: function (p_candy) {
			var price = "";

			p_candy.BuyOptions.forEach(buyoption => {
				if (buyoption.intType == 4) {
					buyoption.lstBalances.forEach(balance => {
						if (balance.intPoints > 0) {
							price = `${balance.intPoints.toLocaleString('es-AR')} ${this.m_get_balance_name(balance.enuPointsType, balance.intBalanceId, (balance.intPoints > 1))}`;
						}
					});
				}
			});

			return price;
		},
		m_get_balance_name: function (enuPointsType, intBalanceId, plural) {
			return this.$root.m_get_balance_name(enuPointsType, intBalanceId, false, plural);
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/CandyTicketHome.vue